import { type FieldTypeConfig, JsonSchemaType } from './types';

export const attachFile: FieldTypeConfig = {
  toJsonSchema: (data) => ({
    type: JsonSchemaType.Array,
    // Restrict to a single file when multiple is explicitly disabled; the
    // field renderer reads `maxItems === 1` to switch off multi-upload.
    ...(data.AllowMultiple === false ? { maxItems: 1 } : {}),
  }),
};
